import { render, staticRenderFns } from "./advertisementRecords.vue?vue&type=template&id=72070e82&scoped=true"
import script from "./advertisementRecords.vue?vue&type=script&lang=js"
export * from "./advertisementRecords.vue?vue&type=script&lang=js"
import style0 from "./advertisementRecords.vue?vue&type=style&index=0&id=72070e82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72070e82",
  null
  
)

export default component.exports